window.bassike = window.bassike || {};

(function (ns) {
    var formatterCache;

    ns.formatSwymPrice = function (priceInCents) {
        var currency = (window.theme && theme.settings && theme.settings.currency) || 'AUD';
        var locale = document.documentElement.lang || undefined;
        var key = locale + '|' + currency;
        if (!formatterCache || formatterCache.key !== key) {
            var fullFmt = new Intl.NumberFormat(locale, { style: 'currency', currency: currency });
            formatterCache = {
                key: key,
                displayDecimals: fullFmt.resolvedOptions().maximumFractionDigits,
                full: fullFmt,
                whole: new Intl.NumberFormat(locale, {
                    style: 'currency',
                    currency: currency,
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                }),
            };
        }
        var amount = Number(priceInCents) / 100;
        var isWhole = formatterCache.displayDecimals === 0
            || Math.round(amount * 100) % 100 === 0;
        return (isWhole ? formatterCache.whole : formatterCache.full).format(amount);
    };

    ns.formatSwymFallbackPrice = function (pr) {
        var swatCurrency = (window._swat && window._swat.currency) || '$';
        return swatCurrency + (pr != null ? pr : '');
    };

    ns.rescanWishlistCollections = function () {
        requestAnimationFrame(function () {
            if (window._swat?.collectionsApi?.initializeCollections) {
                window._swat.collectionsApi.initializeCollections(window._swat, false, Shopify.theme.schema_name);
            }
        });
    };
})(window.bassike);
